module.exports = __webpack_public_path__ + "img/tripadvisor-not-active-icon.cb6e0aec.svg";